import { IReleaseNote } from "../types"

export const RELEASE_MIGRATION: IReleaseNote = {
    status: "UPCOMING",
    title: "API v2 - Migration Guide",
    date: "September 2025",
    releaseType: "Guide",
    notesBodyAllUsers: [
        {
            heading: "Migrate from API v1 to v2",
            content:
                "We're excited to announce that in September 2025, ENA Connect Direct will roll out API v2 in select areas. This new version introduces several important changes to the existing API. This page provides a guide outlining the key updates to help you migrate your code from API v1 to API v2 smoothly.",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using our APIs",
            subtitle: "The relevant changes are as follows:",
            bullets: [
                "Provide Export MPAN: If applicable, DNOs can provide an export MPAN for applications that have reached either the 'Commissioning Accepted' status. Once provided, the application will progress to the EX MPAN PROVIDED state, which is now the terminal status ",
            ],
        },
        {
            subtitle: "What you need to do to get ready:",
            content:
                "To support recent changes to the application status flow, the following endpoints have been updated from v1 to v2. Please ensure your system reflects these changes",
            bullets: [
                "Provide Export MPAN: The endpoint POST /dno-commissioning/v1/export-mpan has been updated to POST /dno-commissioning/v2/export-mpan",
                "Provide Export MPAN: POST /connection-application/v1/applications is now POST /connection-application/v2/applications. This endpoint may now also return the new status: EX MPAN PROVIDED",
            ],
        },
        {
            subtitle: "Roll Out Plan:",
            content:
                "We will be releasing all of these changes to the TST environment in July, and will be in touch to confirm the exact date. API users will be granted access to the TST endpoints to begin testing and adapting their integrations to the new specification. The changes are scheduled to be deployed to PRD in September 2025",
        },
        {
            heading: "For DNOs using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "No changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "No changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "No changes to your functionality",
        },
    ],
}
